// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9v-0";
export var optionCard = "_9v-1";